import './caracteristicasGrid.scss';
import React from 'react';
import { ArticulosColoresState } from '../../../../context/articuloscolores/ArticulosColoresState';
import { ArticulosMedidasState } from '../../../../context/articulosmedidas/ArticulosMedidasState';
import { ArticulosModelosState } from '../../../../context/articulosmodelos/ArticulosModelosState';
import { ArticulosPresentacionesState } from '../../../../context/articulospresentaciones/ArticulosPresentacionesState';
import { ArticulosTallesState } from '../../../../context/articulostalles/ArticulosTallesState';
import { ArticulosTemporadasState } from '../../../../context/articulostemporadas/ArticulosTemporadasState';

import ColorGrid from './Bloques/ColorGrid';
import MedidaGrid from './Bloques/MedidaGrid';
import ModeloGrid from './Bloques/ModeloGrid';
import PresentacionGrid from './Bloques/PresentacionGrid';
import TalleGrid from './Bloques/TalleGrid';
import TemporadaGrid from './Bloques/TemporadaGrid';

const caracteristicas = [
 { nombre: 'Color', componente: ColorGrid, estados: [ArticulosColoresState] },
  { nombre: 'Medida', componente: MedidaGrid, estados: [ArticulosMedidasState] },
  { nombre: 'Modelo', componente: ModeloGrid, estados: [ArticulosModelosState] },
  { nombre: 'Presentacion', componente: PresentacionGrid, estados: [ArticulosPresentacionesState] },
  { nombre: 'Talles', componente: TalleGrid, estados: [ArticulosTallesState] },
  { nombre: 'Temporada', componente: TemporadaGrid, estados: [ArticulosTemporadasState] },
];

const CaracteristicasGrid = ({ datoIdArticulo, dataCarac, addCarac, removeCarac }) => {
  return (
    <div className="grids-container">
      {caracteristicas.map((caracteristica, index) => {
        const ComponenteGrid = caracteristica.componente;
        const [Estado1] = caracteristica.estados; // Desestructura los estados

        return (
          <div className="grid-item" key={index}>
            <label>{caracteristica.nombre}</label>

            {/* Envuelve el componente solo en los estados correspondientes */}
            <Estado1>
                <ComponenteGrid
                  datoIdArticulo={datoIdArticulo}
                  dataCarac={dataCarac}
                  addCarac={addCarac}
                  removeCarac={removeCarac}
                />
            </Estado1>
          </div>
        );
      })}
    </div>
  );
};

export default CaracteristicasGrid;
